module.exports = __webpack_public_path__ + "img/panacea-dashboard.ceb895ac.png";